import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  tag: {
    border: 0,
    backgroundColor: '#E7F3FB',
    color: token.colorPrimary,
    borderRadius: 16,
    padding: '4px 10px 4px 12px'
  },
  treatmentContent: {
    padding: '24px 24px'
  },
  treatmentCard: {
    '& .ant-card-body': {
      padding: 0
    }
  }
}))
